export default __webpack_public_path__ + "static/media/RectangleRight.2d42ae73.svg";